import { apiMap, settings } from '../../../config/constants';
import { apiFetch } from '../../../apiClient';
import { getSessionDatas } from '../../../utils';
import history from '../../../utils/history';
import paths from '../../../config/path';
import { saveAppInfo, showLoaing, updateQianhaiInfo } from '../../App/state/action'

export const GET_BASIC_INFO_MESSAGE = 'GET_BASIC_INFO_MESSAGE';
export const ANSWERS_SUBMIT_DATA = 'ANSWERS_SUBMIT_DATA';
export const UPDATE_BASICINFO_SECTION = 'UPDATE_BASICINFO_SECTION';
export const UPDATE_BASICINFO_BUSINESS = 'UPDATE_BASICINFO_BUSINESS';

export const getBasicInfoMessage = (data) =>({
    type: GET_BASIC_INFO_MESSAGE,
    data
});

export const updateApplicationForBasicInfo = (data) => (dispatch) => {
    dispatch(showLoaing(true));
    apiFetch(apiMap.updateApplication, {
        method: settings.put,
        hostname: settings.hostnameApplication,
        paramsObj: data.data
    })(dispatch).then((result) => {
        dispatch(showLoaing(false));
        dispatch({type: 'ANSWERS_SUBMIT_DATA', data: result.message});
        dispatch(saveAppInfo(data.applicationInfo));
        history.push(paths.accountQuestion.path);
    }).catch( error => {
        dispatch(showLoaing(false));
    });
}

export const saveQuestionsForm = (section) => dispatch => {
    dispatch(showLoaing(true));
    const { applicationId } = getSessionDatas();
    const updateBasicInfoParams = {
        hostname: settings.hostnameQianhai,
        paramsObj: {
            businessInfo: {
                appId: applicationId,
                ...section
            }
        },
        method: settings.put,
    };
    return apiFetch(apiMap.getQianhai, updateBasicInfoParams)(dispatch)
                .then(res => {
                    if (res.respBody && 
                        res.respBody.businessInfo
                        && res.respBody.businessInfo.qianHaiInfo) {
                        dispatch(updateQianhaiInfo(res.respBody.businessInfo.qianHaiInfo))
                    }
                    dispatch(showLoaing(false));
                    return res;
                })
                .catch(error => {
                    dispatch(showLoaing(false));
                    throw error;
                });
 }

export const updateAppInfo = (data) => (dispatch) => {
    dispatch(saveAppInfo(data));
}

export const updateSection = (data) => ({
    type: UPDATE_BASICINFO_SECTION,
    data
});



// WEBPACK FOOTER //
// ./src/views/BasicInfo/state/action.js